export class CashOutRequest {
  public monto: number;
  public cbu: string;
  public cuit: string;
  public titular: string;
  public nombreEntidad: string;
  public versionPlataforma: VersionPlataforma;
  public uuid: string;

  constructor() {
    this.cbu = '';
    this.cuit = '';
    this.titular = '';
    this.nombreEntidad = '';
    this.versionPlataforma = new VersionPlataforma();
    this.uuid = '';
  }
}

export class VersionPlataforma {
  public version: string;
  public plataforma: number;

  constructor() {
    this.version = '';
    this.plataforma = 1;
  }
}
